'use strict';

angular.module('Directives').directive('ngMorris', function($timeout) {
    return {
        'restrict': 'A',
        'scope': {
            options: '=ngMorris'
        },
        'link': function linkingFunction($scope, element, attr) {
            $timeout(function() {
                $scope.options.options.element = element;
                new Morris[$scope.options.type]($scope.options.options);
            });
        },
        'controller': function($scope) {

        }
    }
});


// WEBPACK FOOTER //
// ./js/directives/morris.js